import { render } from "./OtherHome.vue?vue&type=template&id=883bdff4"
import script from "./OtherHome.vue?vue&type=script&lang=js"
export * from "./OtherHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__